import React, { useEffect, useRef } from 'react';
import './custom-cursor.css';

const CustomCursor = () => {
  const circleRef = useRef(null); 
  const mouseRef = useRef({ x: 0, y: 0 }); 
  const circlePosRef = useRef({ x: 0, y: 0 }); 
  const previousMouseRef = useRef({ x: 0, y: 0 }); 
  const currentScaleRef = useRef(0);
  const currentAngleRef = useRef(0);

  const intensityFactor = 1.72; // Adjust this value to increase or decrease the stretch intensity

  useEffect(() => {
    const handleMouseMove = (e) => {
      mouseRef.current = { x: e.clientX, y: e.clientY };
    };

    window.addEventListener('mousemove', handleMouseMove);

    const speed = 0.17;

    const tick = () => {
      // Update circle position smoothly
      circlePosRef.current.x += (mouseRef.current.x - circlePosRef.current.x) * speed;
      circlePosRef.current.y += (mouseRef.current.y - circlePosRef.current.y) * speed;

      // Calculate mouse velocity
      const deltaMouseX = mouseRef.current.x - previousMouseRef.current.x;
      const deltaMouseY = mouseRef.current.y - previousMouseRef.current.y;
      const mouseVelocity = Math.min(Math.sqrt(deltaMouseX ** 2 + deltaMouseY ** 2) * 4, 150);
      
      // Modify stretch intensity by multiplying velocity with intensityFactor
      const scaleValue = (mouseVelocity / 150) * intensityFactor * 0.5;
      currentScaleRef.current += (scaleValue - currentScaleRef.current) * speed;

      // Calculate rotation angle
      const angle = Math.atan2(deltaMouseY, deltaMouseX) * 180 / Math.PI;
      if (mouseVelocity > 20) currentAngleRef.current = angle;

      // Update previous mouse position
      previousMouseRef.current = { ...mouseRef.current };

      // Apply transformations to the circle element
      const circleElement = circleRef.current;
      if (circleElement) {
        circleElement.style.transform = `
          translate(${circlePosRef.current.x}px, ${circlePosRef.current.y}px)
          rotate(${currentAngleRef.current}deg)
          scale(${1 + currentScaleRef.current}, ${1 - currentScaleRef.current})
        `;
      }

      requestAnimationFrame(tick);
    };

    tick();

    return () => {
      window.removeEventListener('mousemove', handleMouseMove);
    };
  }, []);

  return <div ref={circleRef} className="circle"></div>;
};

export default CustomCursor;
